import { ParseJson } from 'src/@types/shared/parseJson';

export function mapJsonArray<T extends ParseJson<T>>(list: any, type: { new (): T }) {
  return list
    .map((item: any) => new type().parseJson(item))
    .filter((x: any) => !!x)
    .map((x: any) => x as T);
}
